import { FaAward, FaGlobe, FaHeart, FaUsers } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">About KSA Holidays</h1>
          <p className="page-subtitle">Your Journey, Our Passion</p>
        </div>
      </div>

      {/* Our Story */}
      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <h2>Our Story</h2>
              <p>
                KSA Holidays is a family-owned travel company dedicated to creating
                unforgettable experiences for travelers worldwide. Founded with a passion for
                exploration and a commitment to excellence, we've been helping families and
                adventurers discover the world's most beautiful destinations.
              </p>
              <p>
                Our journey began with a simple belief: travel should be accessible, enjoyable,
                and transformative. Whether you're seeking adventure, relaxation, or cultural
                immersion, we craft each tour with meticulous attention to detail and genuine care.
              </p>
              <p>
                As a family business, we understand the importance of trust, quality, and
                personalized service. Every member of our team treats each traveler like family,
                ensuring your journey is smooth, safe, and filled with remarkable memories.
              </p>
            </div>
            <div className="about-image">
              <img
                src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800"
                alt="Travel"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{ background: 'var(--bg-light)' }}>
        <div className="container">
          <div className="section-title">
            <h2>Our Core Values</h2>
            <p>What drives us every day</p>
          </div>

          <div className="values-grid grid grid-2">
            <div className="value-card card fade-in">
              <div className="value-icon">
                <FaGlobe />
              </div>
              <h3>Exploration</h3>
              <p>
                We believe in the power of travel to broaden horizons and create
                meaningful connections across cultures.
              </p>
            </div>

            <div className="value-card card fade-in">
              <div className="value-icon">
                <FaAward />
              </div>
              <h3>Excellence</h3>
              <p>
                We're committed to delivering the highest quality experiences,
                from planning to execution.
              </p>
            </div>

            <div className="value-card card fade-in">
              <div className="value-icon">
                <FaUsers />
              </div>
              <h3>Community</h3>
              <p>
                We support local communities and sustainable tourism practices
                wherever we operate.
              </p>
            </div>

            <div className="value-card card fade-in">
              <div className="value-icon">
                <FaHeart />
              </div>
              <h3>Passion</h3>
              <p>
                Our love for travel and adventure fuels everything we do,
                ensuring authentic and memorable experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose KSA Holidays?</h2>
          </div>

          <div className="features-list">
            <div className="feature-item fade-in">
              <div className="feature-number">01</div>
              <div>
                <h3>Expert Local Guides</h3>
                <p>Our professional guides bring destinations to life with their knowledge and passion</p>
              </div>
            </div>

            <div className="feature-item fade-in">
              <div className="feature-number">02</div>
              <div>
                <h3>Personalized Service</h3>
                <p>We tailor each tour to your preferences, ensuring a unique experience</p>
              </div>
            </div>

            <div className="feature-item fade-in">
              <div className="feature-number">03</div>
              <div>
                <h3>Best Value</h3>
                <p>Competitive prices without compromising on quality or safety</p>
              </div>
            </div>

            <div className="feature-item fade-in">
              <div className="feature-number">04</div>
              <div>
                <h3>24/7 Support</h3>
                <p>We're always here for you, before, during, and after your journey</p>
              </div>
            </div>

            <div className="feature-item fade-in">
              <div className="feature-number">05</div>
              <div>
                <h3>Sustainable Tourism</h3>
                <p>We're committed to responsible travel that benefits local communities</p>
              </div>
            </div>

            <div className="feature-item fade-in">
              <div className="feature-number">06</div>
              <div>
                <h3>Safety First</h3>
                <p>Your safety and comfort are our top priorities on every adventure</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section section">
        <div className="container text-center">
          <h2>Ready to Start Your Adventure?</h2>
          <p>Join thousands of happy travelers who've explored the world with us</p>
          <a href="/tours" className="btn btn-primary">Explore Tours</a>
        </div>
      </section>
    </div>
  );
};

export default About;
